<script setup lang="ts">
type Emits = {
  (fn: 'onClickClose'): void
  (fn: 'onClickRetry'): void
}

const emit = defineEmits<Emits>()
</script>

<template>
  <div id="AddressSystemClarifyAddress" class="clarify-address">
    <div class="clarify-address__text">Это ваш точный адрес?</div>

    <div class="clarify-address__actions">
      <the-button
        variant="tertiary"
        size="sm"
        block
        radius="lg"
        @click="emit('onClickRetry')"
      >
        Нет
      </the-button>
      <the-button size="sm" block radius="lg" @click="emit('onClickClose')">
        Да
      </the-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.clarify-address {
  display: flex;
  gap: 20px;
  align-items: center;

  @include media('>=desktop-mini') {
    flex-direction: column;
    gap: 4px;
  }

  &__text {
    flex-shrink: 0;
    width: 158px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: var(--ui-color-white);
    background-color: var(--ui-color-yellow);
    border-radius: 120px;

    @include media('>=desktop-mini') {
      width: unset;
    }
  }

  &__actions {
    display: flex;
    gap: 4px;
    width: 100%;

    .app-button {
      width: 78px;

      @include media('>=desktop-mini') {
        width: 100%;
      }
    }
  }
}
</style>
